import { Button, IconButton, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { ArrowBack, ArrowBackIos } from "@mui/icons-material"; // Fix import
import { grey } from "@mui/material/colors";

const { useNavigate } = require("react-router-dom");

const SettingsHeader = ({ title }) => {
  const navigate = useNavigate();
  return (
    <Stack direction="row" alignItems="center" spacing={2} mb={2}>
      <Button
        variant="outlined"
        color="black"
        onClick={() => navigate("/settings")}
        sx={{
          padding: "4px",
          minWidth: "30px",
          width: "30px",
          height: "30px",
          borderRadius: "6px",
          borderColor: grey[400], // Change border color to gray
        }}
      >
        <ArrowBack sx={{ fontSize: "20px" }} /> {/* Make the icon smaller */}
      </Button>
      <Typography variant="h2" gutterBottom>
        {title}
      </Typography>
    </Stack>
  );
};

export default SettingsHeader;
